var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMosskulle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      display: "block"
    },
    width: 50.4,
    height: 36.2499,
    viewBox: "0 0 50.4 36.2499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.1958 35.9999C36.0219 35.9999 44.7982 29.3999 44.7982 21.2584C44.7982 13.1169 36.0219 6.51687 25.1958 6.51687C14.3697 6.51687 5.59336 13.1169 5.59336 21.2584C5.59336 29.3999 14.3697 35.9999 25.1958 35.9999Z",
    fill: "#F9F6F8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    stroke: "#8A8084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.9626 15.9286C46.9626 25.5396 34.0877 26.7962 25.1956 26.7962C16.3035 26.7962 3.42861 25.5396 3.42861 15.9286V6.85486L46.9626 6.51687V15.9286Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F9F6F8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    stroke: "#8A8084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.3913 3.58791C50.3913 17.6188 35.4817 18.1995 25.1957 18.1995C14.9096 18.1995 0 17.6275 0 3.58791H50.4H50.3913Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C20061"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.1957 7.17577C39.1109 7.17577 50.3913 5.56942 50.3913 3.58789C50.3913 1.60635 39.1109 0 25.1957 0C11.2805 0 0 1.60635 0 3.58789C0 5.56942 11.2805 7.17577 25.1957 7.17577Z",
    fill: "#99004C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.1957 25.3838C26.7689 25.3838 28.0442 24.1073 28.0442 22.5326C28.0442 20.9579 26.7689 19.6813 25.1957 19.6813C23.6224 19.6813 22.3471 20.9579 22.3471 22.5326C22.3471 24.1073 23.6224 25.3838 25.1957 25.3838Z",
    fill: "#C5BABF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.1958 23.9193C25.9609 23.9193 26.5811 23.2985 26.5811 22.5327C26.5811 21.7669 25.9609 21.146 25.1958 21.146C24.4307 21.146 23.8104 21.7669 23.8104 22.5327C23.8104 23.2985 24.4307 23.9193 25.1958 23.9193Z",
    fill: "#F9F6F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosskulle);
export default __webpack_public_path__ + "static/media/mosskulle.3a0641dce4bfe246a90c0996df3302ff.svg";
export { ForwardRef as ReactComponent };